import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { PROSPECTS_DATAKEY } from '../constants/constants';
import { CATEGORY_ID, MEMBER_SEARCH_SCREEN } from '../constants/category';
import categoryModel from '../models/category';
import eventDetail from '../models/eventDetail';
import { utils } from '../functions';

// eslint-disable-next-line consistent-return
export default function memberProspectsReducer(state = initialState.memberProSpec, action) {
  // console.log(action);
  switch (action.type) {
    case types.UPDATE_PROSPECTS: {
      //  console.log(action)
      return state.merge({ ...action.data });
    }
    case types.GET_LIST_ENTITIES_SUCCESS: {
      const { categoryId, data } = action;
      const {
        filtersUserView,
        filterUserLikes,
        filtersUserMatch,
        filterLikes,
        dFilterLikes,
        defaultFilterViews,
        defaultFilterLikes,
        defaultFilterMatch,
      } = Immutable.asMutable(state);
      let updateObject = {};
      if (categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE) {
        updateObject = {
          isGetMemberType: true,
          filtersUserView: {
            ...filtersUserView,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          filterUserLikes: {
            ...filterUserLikes,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          filterLikes: {
            ...filterLikes,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          filtersUserMatch: {
            ...filtersUserMatch,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          defaultFilterViews: {
            ...defaultFilterViews,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          defaultFilterLikes: {
            ...defaultFilterLikes,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          defaultFilterMatch: {
            ...defaultFilterMatch,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
          dFilterLikes: {
            ...dFilterLikes,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.RESET_PROSPECTS_ERROR_STATUS: {
      return state.merge({
        errorUserProfileView: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
        errorUserFav: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
        errorUserMatch: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
        errorUserLikes: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
      });
    }
    case types.GET_USER_PROFILE_PROSPECTS_SUCCESS: {
      const mutalState = Immutable.asMutable(state);
      const { dataKey, data } = action;

      const oldData = mutalState[dataKey];
      const { isUpdateRealtime } = mutalState;
      let updateObject = {};
      let hasMore = false;
      let realData = [];
      if (utils.hasOwnProperty(data, 'users')) {
        hasMore = data.users.length === 24;
        realData = data.users;
      } else {
        hasMore = data.length === 24;
        realData = data;
      }
      const dataAfterRemoveMemberLevelEmpty = realData.filter(itm => itm.detail.memberLevel !== '');
      const funcCheckDuplicate = (a, b) => {
        const aUserId = a?.detail?.userId || a?.userId || -1;
        const bUserId = b?.detail?.userId || b?.userId || -2;
        return aUserId === bUserId;
      };

      switch (dataKey) {
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME:
          updateObject = {
            [dataKey]: isUpdateRealtime
              ? utils.mergeArrayIgnoreDuplicate(dataAfterRemoveMemberLevelEmpty, oldData, funcCheckDuplicate)
              : dataAfterRemoveMemberLevelEmpty,
            isFetchingUserProfileViewTypeViewMe: false,
            pageNumberProfileViewMe: isUpdateRealtime ? mutalState.pageNumberProfileViewMe : 1,
            errorUserProfileView: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
            dataKey,
            isHasMoreItemUserProfileViewTypeViewMe: hasMore,
          };
          break;
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED:
          updateObject = {
            [dataKey]: isUpdateRealtime
              ? utils.mergeArrayIgnoreDuplicate(dataAfterRemoveMemberLevelEmpty, oldData, funcCheckDuplicate)
              : dataAfterRemoveMemberLevelEmpty,
            isFetchingUserProfileViewTypeViewed: false,
            pageNumberProfileViewed: isUpdateRealtime ? mutalState.pageNumberProfileViewed : 1,
            errorUserProfileView: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
            dataKey,
            isHasMoreItemUserProfileViewTypeViewed: hasMore,
          };
          break;
        case PROSPECTS_DATAKEY.USER_LIKES_TYPE_LIKED_ME:
          updateObject = {
            [dataKey]: isUpdateRealtime
              ? utils.mergeArrayIgnoreDuplicate(dataAfterRemoveMemberLevelEmpty, oldData, funcCheckDuplicate)
              : dataAfterRemoveMemberLevelEmpty,
            isFetchingUserUserLikeTypeLikeMe: false,
            pageNumberUserLikedMe: isUpdateRealtime ? mutalState.pageNumberUserLikedMe : 1,
            errorUserFav: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
            dataKey,
            isHasMoreUserLikesTypeLikeMe: hasMore,
            hasDeletedUsersFavedMe: data.hasDeletedUsers,
          };
          break;
        case PROSPECTS_DATAKEY.USER_LIKES_TYPE_HAVE_LIKED:
          updateObject = {
            [dataKey]: isUpdateRealtime ? utils.mergeArrayIgnoreDuplicate(realData, oldData, funcCheckDuplicate) : realData,
            isFetchingUserUserLikeTypeHaveLiked: false,
            pageNumberUserHaveLiked: isUpdateRealtime ? mutalState.pageNumberUserHaveLiked : 1,
            errorUserFav: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
            dataKey,
            isHasMoreUserLikesTypesHaveLiked: hasMore,
          };
          break;
        case PROSPECTS_DATAKEY.USER_MATCH:
          updateObject = {
            [dataKey]: isUpdateRealtime ? utils.mergeArrayIgnoreDuplicate(realData, oldData, funcCheckDuplicate) : realData,
            isFetchingUserUserMatch: false,
            pageNumberUserMatch: isUpdateRealtime ? mutalState.pageNumberUserMatch : 1,
            errorUserMatch: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
            dataKey,
            isHasMoreUserMatch: hasMore,
            hasDeletedUsersMatch: data.hasDeletedUsers,
          };
          break;
        case PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME:
          updateObject = {
            [dataKey]: isUpdateRealtime ? utils.mergeArrayIgnoreDuplicate(realData, oldData, funcCheckDuplicate) : realData,
            isFetchingLikeTypeLikeMe: false,
            pageNumberLikedMe: isUpdateRealtime ? mutalState.pageNumberLikedMe : 1,
            errorUserLikes: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
            dataKey,
            isHasMoreLikesTypeLikeMe: hasMore,
            hasDeletedUsersLikedMe: data.hasDeletedUsers,
          };
          break;
        case PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED:
          updateObject = {
            [dataKey]: isUpdateRealtime ? utils.mergeArrayIgnoreDuplicate(realData, oldData, funcCheckDuplicate) : realData,
            isFetchingLikeTypeHaveLiked: false,
            pageNumberHaveLiked: isUpdateRealtime ? mutalState.pageNumberHaveLiked : 1,
            errorUserLikes: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
            dataKey,
            isHasMoreLikesTypesHaveLiked: hasMore,
            hasDeletedUsersHaveLiked: data.hasDeletedUsers,
          };
          break;
        default:
          return state;
      }
      // state = state.setIn([dataKey], data);
      // isLoadedFirstTime check if dataloadedFirstTime
      // console.log("updateObject", updateObject);
      return state.merge({ ...updateObject, isLoadedFirstTime: true, isUpdateRealtime: false });
    }
    case types.LOAD_MORE_USER_PROFILE_PROSPECTS_SUCCESS: {
      const { dataKey, data, page } = action;
      //  console.log(dataKey, data, page);
      const dataAfterRemoveMemberLevelEmpty = utils.hasOwnProperty(data, 'users')
        ? data.users.filter(itm => itm.detail.memberLevel !== '')
        : data.filter(itm => itm.detail.memberLevel !== '');

      const {
        userProfileViewTypeViewMe,
        userProfileViewTypeViewed,
        // Fav
        userUserLikesTypeLikedMe,
        userUserLikesTypeHaveLiked,
        // Match
        userUserMatch,
        // Likes
        likesTypeLikedMe,
        likesTypeHaveLiked,
      } = Immutable.asMutable(state);
      let updateObject = {};
      switch (dataKey) {
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME:
          updateObject = {
            userProfileViewTypeViewMe: [...userProfileViewTypeViewMe, ...dataAfterRemoveMemberLevelEmpty],
            pageNumberProfileViewMe: page,
            isLoadMoreUserProfileViewTypeViewMe: false,
            loadMoreUserProfileViewTypeViewMe: false,
            isHasMoreItemUserProfileViewTypeViewMe: !(data.length < 24),
            errorUserProfileView: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
          };
          break;
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED:
          updateObject = {
            userProfileViewTypeViewed: [...userProfileViewTypeViewed, ...dataAfterRemoveMemberLevelEmpty],
            pageNumberProfileViewed: page,
            isLoadMoreUserProfileViewTypeViewed: false,
            loadMoreUserProfileViewTypeViewed: false,
            isHasMoreItemUserProfileViewTypeViewed: !(data.length < 24),
            errorUserProfileView: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
          };
          break;
        case PROSPECTS_DATAKEY.USER_LIKES_TYPE_LIKED_ME:
          updateObject = {
            userUserLikesTypeLikedMe: [...userUserLikesTypeLikedMe, ...dataAfterRemoveMemberLevelEmpty],
            pageNumberUserLikedMe: page,
            isLoadMoreUserLikesTypeLikeMe: false,
            loadMoreUserLikesTypeLikeMe: false,
            isHasMoreUserLikesTypeLikeMe: !(data.length < 24),
            errorUserFav: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
          };
          break;
        case PROSPECTS_DATAKEY.USER_LIKES_TYPE_HAVE_LIKED:
          updateObject = {
            userUserLikesTypeHaveLiked: [...userUserLikesTypeHaveLiked, ...dataAfterRemoveMemberLevelEmpty],
            pageNumberUserHaveLiked: page,
            isLoadMoreUSerLikesTypesHaveLiked: false,
            loadMoreUSerLikesTypesHaveLiked: false,
            isHasMoreUserLikesTypesHaveLiked: !(data.length < 24),
            errorUserFav: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
          };
          break;
        case PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME:
          updateObject = {
            likesTypeLikedMe: [...likesTypeLikedMe, ...dataAfterRemoveMemberLevelEmpty],
            pageNumberLikedMe: page,
            isLoadMoreLikesTypeLikeMe: false,
            loadMoreLikesTypeLikeMe: false,
            isHasMoreLikesTypeLikeMe: !(data.users.length < 24),
            errorUserLikes: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
          };
          break;
        case PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED:
          updateObject = {
            likesTypeHaveLiked: [...likesTypeHaveLiked, ...dataAfterRemoveMemberLevelEmpty],
            pageNumberHaveLiked: page,
            isLoadMoreLikesTypesHaveLiked: false,
            loadMoreLikesTypesHaveLiked: false,
            isHasMoreLikesTypesHaveLiked: !(data.users.length < 24),
            errorUserLikes: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
          };
          break;
        case PROSPECTS_DATAKEY.USER_MATCH:
          updateObject = {
            userUserMatch: [...userUserMatch, ...dataAfterRemoveMemberLevelEmpty],
            pageNumberUserMatch: page,
            isLoadMoreUserMatch: false,
            loadMoreUserMatch: false,
            isHasMoreUserMatch: !(data.users.length < 24),
            errorUserMatch: {
              isError: false,
              message: '',
              timeRetry: 0,
              isShowNoConnection: false,
            },
          };
          break;
        default:
          return state;
      }

      return state.merge({ ...updateObject });
    }
    case types.DELETE_USER_PROFILE_VIEW_SUCCESS: {
      const { dataKey, userId } = action;
      let { userProfileViewTypeViewMe, userProfileViewTypeViewed, likesTypeLikedMe, likesTypeHaveLiked } = Immutable.asMutable(state);
      // let updateObject = {};
      switch (dataKey) {
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED: {
          userProfileViewTypeViewed = userProfileViewTypeViewed.filter(item => item.detail.userId !== userId);
          return state.merge({ userProfileViewTypeViewed });
        }
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME: {
          userProfileViewTypeViewMe = userProfileViewTypeViewMe.filter(item => item.detail.userId !== userId);
          return state.merge({ userProfileViewTypeViewMe });
        }
        case PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME: {
          likesTypeLikedMe = likesTypeLikedMe.filter(item => item.detail.userId !== userId);
          return state.merge({ likesTypeLikedMe });
        }
        case PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED: {
          likesTypeHaveLiked = likesTypeHaveLiked.filter(item => item.detail.userId !== userId);
          return state.merge({ likesTypeHaveLiked });
        }
        default:
          return state;
      }
    }
    case types.DELETE_LIST_USER_PROFILE_VIEW_SUCCESS: {
      const { dataKey, ids = [] } = action;
      let { userProfileViewTypeViewMe, userProfileViewTypeViewed, likesTypeLikedMe, likesTypeHaveLiked } = Immutable.asMutable(state);
      // let updateObject = {};
      switch (dataKey) {
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED: {
          userProfileViewTypeViewed = userProfileViewTypeViewed.filter(item => ids.indexOf(item.detail.userId) === -1);
          return state.merge({ userProfileViewTypeViewed });
        }
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME: {
          userProfileViewTypeViewMe = userProfileViewTypeViewMe.filter(item => ids.indexOf(item.detail.userId) === -1);
          return state.merge({ userProfileViewTypeViewMe });
        }
        case PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME: {
          likesTypeLikedMe = likesTypeLikedMe.filter(item => ids.indexOf(item.detail.userId) === -1);
          return state.merge({ likesTypeLikedMe });
        }
        case PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED: {
          likesTypeHaveLiked = likesTypeHaveLiked.filter(item => ids.indexOf(item.detail.userId) === -1);
          return state.merge({ likesTypeHaveLiked });
        }
        default:
          return state;
      }
    }
    case types.DELETE_USER_LIKE_OR_MATCH_SUCCESS: {
      const { userId } = action;
      // console.log(action)
      let { userUserLikesTypeLikedMe, userUserLikesTypeHaveLiked, userUserMatch } = Immutable.asMutable(state);
      userUserLikesTypeLikedMe = userUserLikesTypeLikedMe.filter(item => item.detail.userId !== userId);
      userUserLikesTypeHaveLiked = userUserLikesTypeHaveLiked.filter(item => item.detail.userId !== userId);
      userUserMatch = userUserMatch.filter(item => item.detail.userId !== userId);
      return state.merge({
        userUserLikesTypeLikedMe,
        userUserLikesTypeHaveLiked,
        userUserMatch,
      });
    }
    case types.DELETE_LIST_USER_LIKE_OR_MATCH_SUCCESS: {
      const { ids = [] } = action;
      // console.log(action)
      let { userUserLikesTypeLikedMe, userUserLikesTypeHaveLiked, userUserMatch } = Immutable.asMutable(state);
      userUserLikesTypeLikedMe = userUserLikesTypeLikedMe.filter(item => ids.indexOf(item.detail.userId) === -1);
      userUserLikesTypeHaveLiked = userUserLikesTypeHaveLiked.filter(item => ids.indexOf(item.detail.userId) === -1);

      userUserMatch = userUserMatch.filter(item => ids.indexOf(item.detail.userId) === -1);
      return state.merge({
        userUserLikesTypeLikedMe,
        userUserLikesTypeHaveLiked,
        userUserMatch,
      });
    }
    case types.POST_USERS_MEMBER_SEARCH_ACTION_SUCCESS:
    case types.POST_USERS_MEMBER_PROFILE_ACTION_SUCCESS: {
      let { userUserLikesTypeHaveLiked, userUserMatch, likesTypeHaveLiked } = Immutable.asMutable(state);
      const { userProfileViewTypeViewMe, userProfileViewTypeViewed, userUserLikesTypeLikedMe, likesTypeLikedMe } =
        Immutable.asMutable(state);
      const { dataKey, fromProfileIndex } = action.params;
      const { index, user } = action;
      const dataIndex = fromProfileIndex || index;
      // console.log('MemberProspects reducer', action)
      // console.log(dataKey)
      let data = [];
      if (dataKey === PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED) {
        data = userProfileViewTypeViewed;
      }
      if (dataKey === PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME) {
        data = userProfileViewTypeViewMe;
      }
      if (dataKey === PROSPECTS_DATAKEY.USER_LIKES_TYPE_HAVE_LIKED) {
        data = userUserLikesTypeHaveLiked;
      }
      if (dataKey === PROSPECTS_DATAKEY.USER_LIKES_TYPE_LIKED_ME) {
        data = userUserLikesTypeLikedMe;
      }
      if (dataKey === PROSPECTS_DATAKEY.USER_MATCH) {
        data = userUserMatch;
      }
      if (dataKey === PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED) {
        data = likesTypeHaveLiked;
      }
      if (dataKey === PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME) {
        data = likesTypeLikedMe;
      }
      if (dataKey && data.length > 0) {
        if (data[dataIndex] && data[dataIndex].profileIntersection) {
          const { LIKE, UNLIKE, FAVORITE } = MEMBER_SEARCH_SCREEN.ACTION_TYPE;
          let updateObject = null;
          let checkUpdate = true;

          //  console.log(action)
          // switch (action.actionType) {
          //     case LIKE:
          //     case UNLIKE:
          if (action.actionSuccess) {
            let { isLikedMutual } = action.user.profileIntersection;
            if (!(action.params.Type === FAVORITE && action.actionType === UNLIKE)) {
              isLikedMutual = action.isFavouritedMutualMatch ? action.isFavouritedMutualMatch : action.isLikedMutualMatch;
            }
            updateObject = {
              isFavorited:
                dataKey === PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME ? false : action.params.Type === FAVORITE && action.actionType === LIKE,
              isFavoritedMutual: dataKey === PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME ? false : action.isFavouritedMutualMatch,
              isLiked:
                action.params.Type === FAVORITE && action.actionType === UNLIKE
                  ? action.user.profileIntersection?.isLiked
                  : action.actionType === LIKE,
              isLikedMutual,
            };

            if (action.actionType === UNLIKE && dataKey === PROSPECTS_DATAKEY.USER_MATCH) {
              if (!updateObject.isFavoritedMutual && updateObject.isLikedMutual) {
                // Remove favorite mutual
                userUserMatch = userUserMatch.map(itm => {
                  let newUser = itm;
                  if (itm.detail.userId === action.user.detail.userId) {
                    newUser = {
                      ...newUser,
                      profileIntersection: {
                        ...newUser.profileIntersection,
                        ...updateObject,
                      },
                    };
                  }
                  return newUser;
                });
              } else {
                // Remove user
                userUserMatch = userUserMatch.filter(item => item.detail.userId !== action.user.detail.userId);
              }
              checkUpdate = false;
              state = state.merge({ userUserMatch });
            }
            if (action.actionType === UNLIKE && dataKey === PROSPECTS_DATAKEY.USER_LIKES_TYPE_HAVE_LIKED) {
              userUserLikesTypeHaveLiked = userUserLikesTypeHaveLiked.filter(
                (item, index) => item.detail.userId !== action.user.detail.userId
              );
              checkUpdate = false;
              state = state.merge({ userUserLikesTypeHaveLiked });
              // /console.log('MemberProspects reducer', action.user.detail.userId, state)
            }
            if (action.actionType === UNLIKE && dataKey === PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED) {
              likesTypeHaveLiked = likesTypeHaveLiked.filter((item, index) => item.detail.userId !== action.user.detail.userId);
              checkUpdate = false;
              state = state.merge({ likesTypeHaveLiked });
              // /console.log('MemberProspects reducer', action.user.detail.userId, state)
            }
            if (action.actionType === UNLIKE && data[dataIndex].profileIntersection?.isFavorited) {
              if (action.res && !action.res.actionSuccess) {
                break;
              } else {
                updateObject = {
                  ...updateObject,
                  isFavorited: false,
                  isFavoritedMutual: false,
                };
                if (
                  dataKey !== PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED &&
                  dataKey !== PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME &&
                  dataKey !== PROSPECTS_DATAKEY.USER_MATCH
                ) {
                  // checkUpdate = false;
                  // userUserLikesTypeLikedMe = userUserLikesTypeLikedMe.filter((item) => item.detail.userId !== action.user.detail.userId);
                  userUserLikesTypeHaveLiked = userUserLikesTypeHaveLiked.filter(item => item.detail.userId !== action.user.detail.userId);
                  state = state.merge({
                    userUserLikesTypeLikedMe,
                    userUserLikesTypeHaveLiked,
                  });
                }
              }
            }
          }
          //         break;
          // }
          // console.log("updateObject 3:", updateObject);
          if (updateObject && checkUpdate) {
            state = state.setIn([dataKey, dataIndex], {
              ...data[dataIndex],
              profileIntersection: {
                ...data[dataIndex].profileIntersection,
                ...updateObject,
              },
            });
          }
        }
      }

      return state;
    }
    case types.UPDATE_MEMBERTYPE_STATE_LIST: {
      const { filterId, flag, index } = action;
      state = state.setIn([filterId, 'showMeMemberType', 'contentTabs', 0, 'data', index, 'active'], flag);
      return state;
    }
    case types.UPDATE_ALL_MEMBERTYPE_STATE_LIST: {
      const { filterId, genders } = action;
      state = state.setIn([filterId, 'showMeMemberType', 'contentTabs', 0, 'data'], genders);
      return state;
    }
    case types.GET_USER_SEARCH_SETTINGS_SUCCESS: {
      const {
        filtersUserView,
        // Fav
        filterUserLikes,
        // Match
        filtersUserMatch,
        // Likes
        filterLikes,
        // Likes
        dFilterLikes,
        defaultFilterViews,
        // Fav
        defaultFilterLikes,
        // Match
        defaultFilterMatch,
      } = Immutable.asMutable(state);
      //  console.log(action)

      return state.merge({
        isGetUserSearchSetting: true,
        filtersUserView: {
          ...filtersUserView,
          location: {},
          maxAge: action.data.filters.maxAge,
          memberType: action.data.filters.memberType,
          minAge: action.data.filters.minAge,
          searchRadius: action.data.filters.searchRadius,
          seekingMemberType: action.data.filters.seekingMemberType,
        },
        filterUserLikes: {
          ...filterUserLikes,
          location: {},
          maxAge: action.data.filters.maxAge,
          memberType: action.data.filters.memberType,
          minAge: action.data.filters.minAge,
          searchRadius: action.data.filters.searchRadius,
          seekingMemberType: action.data.filters.seekingMemberType,
        },
        filterLikes: {
          ...filterLikes,
          location: {},
          maxAge: action.data.filters.maxAge,
          memberType: action.data.filters.memberType,
          minAge: action.data.filters.minAge,
          searchRadius: action.data.filters.searchRadius,
          seekingMemberType: action.data.filters.seekingMemberType,
        },
        filtersUserMatch: {
          ...filtersUserMatch,
          location: {},
          maxAge: action.data.filters.maxAge,
          memberType: action.data.filters.memberType,
          minAge: action.data.filters.minAge,
          searchRadius: action.data.filters.searchRadius,
          seekingMemberType: action.data.filters.seekingMemberType,
        },
        defaultFilterViews: {
          ...defaultFilterViews,
          location: {},
          maxAge: action.data.filters.maxAge,
          memberType: action.data.filters.memberType,
          minAge: action.data.filters.minAge,
          searchRadius: action.data.filters.searchRadius,
          seekingMemberType: action.data.filters.seekingMemberType,
        },
        defaultFilterLikes: {
          ...defaultFilterLikes,
          location: {},
          maxAge: action.data.filters.maxAge,
          memberType: action.data.filters.memberType,
          minAge: action.data.filters.minAge,
          searchRadius: action.data.filters.searchRadius,
          seekingMemberType: action.data.filters.seekingMemberType,
        },
        dFilterLikes: {
          ...dFilterLikes,
          location: {},
          maxAge: action.data.filters.maxAge,
          memberType: action.data.filters.memberType,
          minAge: action.data.filters.minAge,
          searchRadius: action.data.filters.searchRadius,
          seekingMemberType: action.data.filters.seekingMemberType,
        },
        defaultFilterMatch: {
          ...defaultFilterMatch,
          location: {},
          maxAge: action.data.filters.maxAge,
          memberType: action.data.filters.memberType,
          minAge: action.data.filters.minAge,
          searchRadius: action.data.filters.searchRadius,
          seekingMemberType: action.data.filters.seekingMemberType,
        },
      });
    }
    case types.GET_USER_PROFILE_PROSPECTS_ERROR: {
      let updateParams = {};
      const { timeRetry } = state.errorUserProfileView;
      switch (action.dataKey) {
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME:
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED:
          updateParams = {
            isFetchingUserProfileViewTypeViewMe: false,
            isFetchingUserProfileViewTypeViewed: false,
            isLoadMoreUserProfileViewTypeViewMe: false,
            isLoadMoreUserProfileViewTypeViewed: false,
            errorUserProfileView: {
              isError: true,
              message: action.message,
              timeRetry: timeRetry + 1,
              isShowNoConnection: timeRetry >= 7,
            },
          };
          break;
        case PROSPECTS_DATAKEY.USER_LIKES_TYPE_LIKED_ME:
        case PROSPECTS_DATAKEY.USER_LIKES_TYPE_HAVE_LIKED:
          updateParams = {
            isFetchingUserUserLikeTypeLikeMe: false,
            isFetchingUserUserLikeTypeHaveLiked: false,
            isLoadMoreUserLikesTypeLikeMe: false,
            isLoadMoreUSerLikesTypesHaveLiked: false,
            errorUserFav: {
              isError: true,
              message: action.message,
              timeRetry: timeRetry + 1,
              isShowNoConnection: timeRetry >= 7,
            },
          };
          break;
        case PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME:
        case PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED:
          updateParams = {
            isFetchingLikeTypeLikeMe: false,
            isFetchingLikeTypeHaveLiked: false,
            isLoadMoreLikesTypeLikeMe: false,
            isLoadMoreLikesTypesHaveLiked: false,
            errorUserLikes: {
              isError: true,
              message: action.message,
              timeRetry: timeRetry + 1,
              isShowNoConnection: timeRetry >= 7,
            },
          };
          break;
        case PROSPECTS_DATAKEY.USER_MATCH:
          updateParams = {
            isFetchingUserUserMatch: false,
            isLoadMoreUserMatch: false,
            errorUserMatch: {
              isError: true,
              message: action.message,
              timeRetry: timeRetry + 1,
              isShowNoConnection: timeRetry >= 7,
            },
          };
          break;
        default:
          return state;
      }

      return state.merge({ ...updateParams });
    }
    case types.GET_PROSPECTS_COUNT: {
      const { count } = Immutable.asMutable(state);
      return state.merge({
        isLoadingCount: false,
        count: {
          ...count,
          ...action.data,
        },
      });
    }
    case types.GET_PROSPECTS_COUNT_ERROR: {
      return state.merge({
        isLoadingCount: false,
      });
    }
    case types.USER_LOGOUT_SUCCESS: {
      const reset = {
        errorUserProfileView: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
        errorUserFav: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
        errorUserMatch: {
          isError: false,
          message: '',
          timeRetry: 0,
          isShowNoConnection: false,
        },
        isLoadedFirstTime: false,
        dataKey: null,
        // User ProfileView
        isGetUserSearchSetting: false,
        isGetMemberType: false,
        isFetchingUserProfileViewTypeViewMe: null,
        isFetchingUserProfileViewTypeViewed: null,
        userProfileViewTypeViewMe: [],
        userProfileViewTypeViewed: [],
        loadMoreUserProfileViewTypeViewMe: false,
        isLoadMoreUserProfileViewTypeViewMe: false,
        isHasMoreItemUserProfileViewTypeViewMe: true,
        loadMoreUserProfileViewTypeViewed: false,
        isLoadMoreUserProfileViewTypeViewed: false,
        isHasMoreItemUserProfileViewTypeViewed: true,
        pageNumberProfileViewMe: 0,
        pageNumberProfileViewed: 0,
        filtersUserView: {
          minAge: 18,
          maxAge: 99,
          location: {},
          searchRadius: 30,
          showMeMemberType: new categoryModel({
            id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
          }),
          matchingMember: false,
          isHasChangeFilter: false,
          isDoFilter: false,
        },
        defaultFilterViews: {
          minAge: 18,
          maxAge: 99,
          location: {},
          searchRadius: 30,
          showMeMemberType: new categoryModel({
            id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
          }),
          matchingMember: false,
          isHasChangeFilter: false,
          isDoFilter: false,
        },

        // User UserLikes
        isFetchingUserUserLikeTypeLikeMe: null,
        isFetchingUserUserLikeTypeHaveLiked: null,
        userUserLikesTypeLikedMe: [],
        userUserLikesTypeHaveLiked: [],
        loadMoreUserLikesTypeLikeMe: false,
        isLoadMoreUserLikesTypeLikeMe: false,
        isHasMoreUserLikesTypeLikeMe: true,
        loadMoreUSerLikesTypesHaveLiked: false,
        isLoadMoreUSerLikesTypesHaveLiked: false,
        isHasMoreUserLikesTypesHaveLiked: true,
        pageNumberUserLikedMe: 0,
        pageNumberUserHaveLiked: 0,
        filterUserLikes: {
          minAge: 18,
          maxAge: 99,
          location: {},
          searchRadius: 30,
          showMeMemberType: new categoryModel({
            id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
          }),
          matchingMember: false,
          isFavourite: false,
          isHasChangeFilter: false,
          isDoFilter: false,
        },
        defaultFilterLikes: {
          minAge: 18,
          maxAge: 99,
          location: {},
          searchRadius: 30,
          showMeMemberType: new categoryModel({
            id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
          }),
          matchingMember: false,
          isFavourite: false,
          isHasChangeFilter: false,
          isDoFilter: false,
        },

        isHasChangeFilterLikes: false,
        isDoFilterLikes: false,
        // User UserMatches
        isFetchingUserUserMatch: null,
        userUserMatch: [],
        loadMoreUserMatch: false,
        isLoadMoreUserMatch: false,
        isHasMoreUserMatch: true,
        pageNumberUserMatch: 0,
        filtersUserMatch: {
          minAge: 18,
          maxAge: 99,
          location: {},
          searchRadius: 30,
          showMeMemberType: new categoryModel({
            id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
          }),
          matchingMember: false,
          isFavourite: false,
          isHasChangeFilter: false,
          isDoFilter: false,
        },
        defaultFilterMatch: {
          minAge: 18,
          maxAge: 99,
          location: {},
          searchRadius: 100,
          showMeMemberType: new categoryModel({
            id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
          }),
          matchingMember: false,
          isFavourite: false,
          isHasChangeFilter: false,
          isDoFilter: false,
        },
        isLoadingCount: false,
        count: {
          profileView: 0,
          favourites: 0,
          matches: 0,
        },
        // Likes
        isFetchingLikeTypeLikeMe: null,
        isFetchingLikeTypeHaveLiked: null,
        likesTypeLikedMe: [],
        likesTypeHaveLiked: [],
        loadMoreLikesTypeLikeMe: false,
        isLoadMoreLikesTypeLikeMe: false,
        isHasMoreLikesTypeLikeMe: true,
        loadMoreLikesTypesHaveLiked: false,
        isLoadMoreLikesTypesHaveLiked: false,
        isHasMoreLikesTypesHaveLiked: true,
        pageNumberLikedMe: 0,
        pageNumberHaveLiked: 0,
        filterLikes: {
          minAge: 18,
          maxAge: 99,
          location: {},
          searchRadius: 30,
          showMeMemberType: new categoryModel({
            id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
          }),
          matchingMember: false,
          isFavourite: false,
          isHasChangeFilter: false,
          isDoFilter: false,
        },
        dFilterLikes: {
          minAge: 18,
          maxAge: 99,
          location: {},
          searchRadius: 30,
          showMeMemberType: new categoryModel({
            id: CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE,
          }),
          matchingMember: false,
          isFavourite: false,
          isHasChangeFilter: false,
          isDoFilter: false,
        },
        isChangedFilterLikes: false,
        isSearchFilterLikes: false,
        loadInitDataTime: 0,
      };
      return state.merge({
        ...state,
        ...reset,
      });
    }

    // eslint-disable-next-line no-case-declarations
    case types.GET_STATE_COUNT_SUCCESS:
      const { data, params } = action;
      const updateParams = {};
      let propsStateCount = '';
      let propsSubStateCount = '';
      switch (params.dataKey) {
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEW_ME:
          propsStateCount = 'stateCountProfileViewTypesViewMe';
          propsSubStateCount = 'stateCountSubProfileViewTypesViewMe';
          break;
        case PROSPECTS_DATAKEY.USER_PROFILE_VIEW_TYPE_VIEWED:
          propsStateCount = 'stateCountProfileViewTypeViewed';
          propsSubStateCount = 'stateCountSubProfileViewTypeViewed';
          break;
        case PROSPECTS_DATAKEY.USER_LIKES_TYPE_LIKED_ME:
          propsStateCount = 'stateCountFavouritesTypeLikeMe';
          propsSubStateCount = 'stateCountSubFavTypeLikeMe';
          break;
        case PROSPECTS_DATAKEY.USER_LIKES_TYPE_HAVE_LIKED:
          propsStateCount = 'stateCountFavouritesTypeHaveLiked';
          propsSubStateCount = 'stateCountSubFavTypeHaveLiked';
          break;
        case PROSPECTS_DATAKEY.USER_MATCH:
          propsStateCount = 'stateCountMatch';
          propsSubStateCount = 'stateCountSubMatch';
          break;
        case PROSPECTS_DATAKEY.LIKES_TYPE_LIKED_ME:
          propsStateCount = 'stateCountLikesTypeLikedMe';
          propsSubStateCount = 'stateCountSubLikesTypeLikedMe';
          break;
        case PROSPECTS_DATAKEY.LIKES_TYPE_HAVE_LIKED:
          propsStateCount = 'stateCountLikesTypeHaveLiked';
          propsSubStateCount = 'stateCountSubLikesTypeHaveLiked';
          break;
        default:
          break;
      }
      updateParams[propsSubStateCount] = data;
      updateParams[propsStateCount] = [];
      if (data.length > 0) {
        const itemTotalCount = data.find(itm => itm.value === 1);
        updateParams[propsStateCount].push(
          eventDetail.getEventPopularDefault({
            Text: 'Australia',
            Count: itemTotalCount ? itemTotalCount.count : 0,
          })
        );
      }

      return state.merge({ ...updateParams });
    case types.PROSPECTS_TIME_LOAD_INIT_DATA: {
      return state.merge({ loadInitDataTime: action.time });
    }
    default:
      return state;
  }
}
